import HelpOverview from "./HelpOverview";
import MyTravelHelp from "./MyTravelHelp";
import MyRoutesHelp from "./MyRoutesHelp";
import FAQs from "./FAQs";
import ExpresswayNamesAndNumbers from "./ExpresswayNamesAndNumbers";
import HelpLayout from "./HelpLayout";
import Mileposts from "./Mileposts";

const module = {
  routeProps: {
    path: "/Help",
    component: HelpLayout,
  },

  name: "Help",
  label: "Help",
  submodules: [
    HelpOverview,
    MyTravelHelp,
    MyRoutesHelp,
    FAQs,
    ExpresswayNamesAndNumbers,
    Mileposts,
  ],
  showOnHeader: true,
  defaultOpen: false,
};

export default module;
